import {createRequestActions} from '../utils';

import * as productCategoryTypes from './productCategoryTypes';

export const saveProductCategory = createRequestActions(productCategoryTypes.SAVE_PRODUCT_CATEGORY);
export const deleteProductCategory = createRequestActions(productCategoryTypes.DELETE_PRODUCT_CATEGORY);
export const markProductCategoryAsPrincipal = createRequestActions(productCategoryTypes.MARK_PRODUCT_CATEGORY_AS_PRINCIPAL);
export const listProductCategories = createRequestActions(productCategoryTypes.PRODUCT_CATEGORY_LIST);
